/* eslint-disable */
import moment from 'moment';
import { apiWPRequest } from '@/calls/helpers';

const getNews = async () => {
  try {
    const request = await apiWPRequest('wp-json/wp/v2/new?per_page=6&page=1&categorie_news=191');

    const data = request.map((item, index) => {
      return {
        title: item.title.rendered,
        bannerID: item.acf.banner,
        id: item.id,
        slug: item.slug,
        date: moment(item.date).format('DD.MM.YYYY'),
        dateReverse: moment(item.date).format('YYYYMMDD'),
        data: item
      }
    });

    for (let i = 0; i < data.length; i++) {
      const news = data[i];
      const req = await getNewImage(news.bannerID);

      news.picture = req.data;
    }

    data.sort((a, b) => (a.dateReverse < b.dateReverse) ? 1 : -1);

    return {
      success: true,
      data
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const getNewImage = async (id) => {
  try {
    const req = await apiWPRequest(`wp-json/wp/v2/media/${id}`);

    return {
      success: true,
      data: {
        src: req.media_details.sizes.box.source_url,
        src2x: req.media_details.sizes.medium_large.source_url,
        alt: req.alt_text
      }
    };
  } catch (error) {
    return {
      error: true,
      data: null
    }
  }
}

const getNewsDetail = async (slug) => {
  try {
    const request = await apiWPRequest(`/wp-json/wp/v2/new?slug=${slug}`);
    const news = request[0];
    let content = news.acf.full_tpl[0].tpl_full_txt_col1;

    if (!content) {
      if (news.acf.full_tpl[0].acf_fc_layout === 'contentTab' && news.acf.full_tpl[0].contentTab_section) {
        const tabs = news.acf.full_tpl[0].contentTab_section;
        content = [];

        for (let i = 0; i < tabs.length; i++) {
          const tab = tabs[i];
          const htmlContent = `<h2>${tab.titre}</h2>${tab.contenu}`;
          content.push(htmlContent);
        }

        content = content.join();
      }
    }

    content = content.replace(/<p>&nbsp;<\/p>/g, '');

    const data = {
      title: news.title.rendered,
      bannerID: news.acf.banner,
      id: news.id,
      slug: news.slug,
      content,
      date: moment(news.date).format('DD.MM.YYYY'),
      data: news
    };

    // Banner
    const req = await getNewImage(data.bannerID);
    data.picture = req.data;

    return {
      success: true,
      data
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

export {
  // eslint-disable-next-line
  getNews,
  getNewsDetail
};
